<div class="card h-100">
  <!-- Card Header -->
  <div class="card-header d-flex justify-content-between align-items-start border-0 bg-transparent p-3">
    <h5 class="card-title mb-0">Average Active Vulnerabilities</h5>
    <div class="last-updated-indicator">
      <small class="text-muted">
        <span style="color: #64748b; font-weight: 400">Last updated:</span>
        {{ vssOverviewDataResponse().last_fetch_datetime | date: 'short' }}
      </small>
    </div>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onViewData()"
    ></kendo-dropdownbutton>
  </div>
  <!-- Card Body -->
  <div class="card-body p-3">
    <!-- Patch Status Cards -->
    <div class="row g-2 mb-2">
      <div class="col-6">
        <app-metric-card
          title="Patch Available"
          [currentValue]="vssOverviewDataResponse().patchable"
          [hideComparison]="true"
          [hidePrevious]="true"
          [showLeftBorder]="true"
          cardClass="compact-vss-card"
        >
          <ng-template #subtext>
            <div class="d-flex justify-content-between align-items-baseline">
              <div class="metric-subtext">Patches ready to apply</div>
              <span class="badge bg-warning bg-opacity-75">{{ vssOverviewDataResponse().patched_percentage }}%</span>
            </div>
          </ng-template>
        </app-metric-card>
      </div>
      <div class="col-6">
        <app-metric-card
          title="No Patch Available"
          [currentValue]="vssOverviewDataResponse().unpatchable"
          [hideComparison]="true"
          [hidePrevious]="true"
          [showLeftBorder]="true"
          cardClass="compact-vss-card"
        >
          <ng-template #subtext>
            <div class="d-flex justify-content-between align-items-baseline">
              <div class="metric-subtext">Awaiting vendor patches</div>
              <span class="badge bg-danger bg-opacity-75">{{ vssOverviewDataResponse().unpatchable_percentage }}%</span>
            </div>
          </ng-template>
        </app-metric-card>
      </div>
      <!-- Vulnerability Flow Visualization -->
      <div class="vulnerability-flow">
        <!-- Total Instances -->
        <div class="flow-section">
          <div class="flow-content">
            <div class="flow-number">{{ vssOverviewDataResponse().total_instances }}</div>
            <div class="flow-subtitle">Total Instances</div>
          </div>
        </div>
        <!-- Flow Arrow -->
        <div class="flow-arrow">
          <div class="arrow-line"></div>
          <div class="consolidation-text">{{ vssOverviewDataResponse().percent_consolidated }}%</div>
        </div>
        <!-- Unique Vulnerabilities -->
        <div class="flow-section">
          <div class="flow-content">
            <div class="flow-number">{{ vssOverviewDataResponse().unique_cves }}</div>
            <div class="flow-subtitle">Unique CVEs</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>Average Active Vulnerabilities</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable [data-href]="url" [columns]="datatableColumns" [useOData]="true"></app-datatable>
      </div>
    }
  </kendo-dialog>
}
